import { ClassSwiperOffice } from "./modules/ClassSwiperOffice.js";

document.addEventListener("DOMContentLoaded", function () {

  /* ========== swiper ========== */
  const swiperOfficeFlag = document.querySelectorAll('.js-office-slider') != null
  if (swiperOfficeFlag) {
    const swiperOfficeElems = document.querySelectorAll('.js-office-slider')
    swiperOfficeElems.forEach((swiperOfficeElem) => {
      const swiperOffice = new ClassSwiperOffice(swiperOfficeElem)
    })
  }
});
